module.exports = __webpack_public_path__ + "img/whydah.8cd68bed.jpg";